/**
 * WordPress dependencies
 */
import { createReduxStore, register } from '@wordpress/data';

/**
 * Internal dependencies
 */
import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';

export const store = createReduxStore( 'nab/checker', {
	reducer,
	actions,
	selectors,
} );
register( store );
